import { ListStatus } from '@/store/types';
import BannerStandOrder from './banner-stand-order';

export enum BannerStandOrdersActions {
  LOAD_LIST = 'LOAD_LIST',
  LOAD_ORDER = 'LOAD_ORDER',
}

export enum BannerStandOrdersMutations {
  SET_LIST = 'SET_LIST',
  SET_LIST_STATUS = 'SET_LIST_STATUS',
  SET_LIST_PAGINATION = 'SET_LIST_PAGINATION',
  SET_CURRENT = 'SET_CURRENT',
}

export interface BannerStandOrdersState {
  list: BannerStandOrder[];
  listStatus: ListStatus;
  listPagination: {
    currentPage: number;
    lastPage: number;
    total: number;
  };
  current: BannerStandOrder | null;
}
